export default __webpack_public_path__ + "static/media/TE.cd0ac1f3.mp3";